/**This file contains a constant object that has properties that are necessary
 * for the build found in the `development` configuration in `angular.json`.
 */

export const environment = {
	environment: 'dev',
	production: false,
	financialUrl: 'https://api-dev.int.mss.ford.com/apisacim/api/v1/sacim',
	baseUrl: '',
	samisToken: 'd8da212f',
	apsDescription: 'SACIM',
	tlkUrl: 'https://api-dev.int.mss.ford.com/apisacim/api/v1/tlk',
	msalConfig: {
		clientId: '7ae4c423-d3a4-4b2c-9eba-34a35d4e52bd',
		authority:
			'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0/',
		redirectUri: 'https://wwwdev.creditlimit.ford.com/',
	},
	apiConfig: {
		scopes: ['api://3d49b12c-bf69-4839-a7a2-057b23d969be/.default'],
		uri: 'https://api-dev.int.mss.ford.com/apisacim/api/v1/sacim',
	},
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
